<template>
  <div>
    <div>
      <div class="c-card-body">
        <datatable
          ref="datatable"
          module="transfer-personal-trainer"
          :title="title"
          :url="url"
          :columns="columns"
          :on-click-create="onClickCreate"
          :on-click-update="onClickUpdate"
          :on-click-delete="onClickDelete"
          :action-width="180"
        >
        <template v-slot:[`item.created_at`]="{ item }">
            <div v-if="item.created_at != null">
              {{ item.created_at | moment("DD/MM/YYYY") }}
            </div>
            <div v-else>-</div>
        </template>
        <template v-slot:[`item.status`]="{ item }">
            <v-chip
              :color="item.status === 'verified' ? 'green' : item.status === 'unverified' ? 'red' : 'blue'"
              text-color="white"
              small
            >
              {{ item.status.charAt(0).toUpperCase() + item.status.slice(1) }}
            </v-chip>
        </template>
      </datatable>
      </div>
    </div>
    <form-action ref="form" module="transfer-personal-trainer" :success="formSuccess" />
    <delete-dialog
      ref="delete"
      url="transfer-personal-trainer"
      :success="deleteSuccess"
    ></delete-dialog>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Datatable from "@/view/component/Datatable.vue";
import DeleteDialog from "@/view/component/DeleteDialog.vue";
import FormAction from "./Form";

export default {
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Manajemen Member", route: "" },
      { title: "Transfer Personal Trainer" }
    ]);
  },
  data() {
    return {
      title: "Transfer  Personal Trainer",
      url: "transfer-personal-trainer/data",
      columns: [
        {
          value: "id"
        },
        {
          text: "Dari Personal Trainer",
          value: "from_personal_trainer_name",
          sortable: true,
          searchable: true
        },
        {
          text: "Ke Personal Trainer",
          value: "to_personal_trainer_name",
          sortable: true,
          searchable: true
        },
        {
          text: "Paket yang Dipindahkan",
          value: "sales_item_name",
          sortable: true,
          searchable: true
        },
        {
          text: "Sisa Kuota",
          value: "quota_session_transfer",
          sortable: true,
          searchable: true
        },

      ]
    };
  },
  methods: {
    onClickCreate() {
      this.$refs.form.open();
    },
    onClickUpdate(item) {
      this.$refs.form.open(item.id);
    },
    onClickDelete(item) {
      this.$refs.delete.open(item.id);
    },
    formSuccess() {
      this.$refs.datatable.getData();
    },
    deleteSuccess() {
      this.$refs.datatable.getData();
    }
  },
  components: {
    Datatable,
    DeleteDialog,
    FormAction
  }
};
</script>
